/** @flow */
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import ui from 'common/modules/ui/reducers/uiReducer';
import authentication from '../modules/authentication/reducers/authenticationReducer';
import UserManagementReducer from '../modules/userManagement/reducers/userManagementReducer';
import CustomersReducer from '../modules/customers/reducers/customersReducer';
import SessionReducer from '../modules/authentication/session/reducers/sessionReducer';
import SalesReducer from '../modules/sales/reducer/';
import SpotsReducer from '../modules/spots/reducers/spotReducer';
import SpotInventoryReducer from '../modules/spots/reducers/spotInventoryReducer';
import UserProfileReducer from '../modules/userProfile/reducers/userProfileReducer';
import RadioConfigurationReducer from '../modules/radioConfiguration/reducers/radioConfigurationReducer';
import SalesInventoryReducer from '../modules/salesInventory/reducers/salesInventoryReducer';
import PromotionReducer from '../modules/promotions/reducers/promotionReducer';

import { SWITCH_RADIO_SUCCESS, CLOSE_SESSION } from '../modules/authentication/session/actions/sessionActions';
import type { AppState } from '../types/State';
import type { Action } from '../types/Action';

const reducers = {
  authentication,
  ui,
  form,
  session: SessionReducer,
  sales: SalesReducer,
  userManagement: UserManagementReducer,
  spots: SpotsReducer,
  spotInventory: SpotInventoryReducer,
  customers: CustomersReducer,
  userProfile: UserProfileReducer,
  radioConfiguration: RadioConfigurationReducer,
  salesInventory: SalesInventoryReducer,
  promotion: PromotionReducer,
};

export type Reducers = typeof reducers;

const rootReducer = combineReducers(reducers);

const appReducer = (state: AppState, action: Action) => {
  let newState = state;
  if (action.type === SWITCH_RADIO_SUCCESS) {
    newState = {
      session: state.session,
      ui: state.ui,
      sales: { estimation: { progress: state.sales.estimation.progress } },
    };
  }

  if (action.type === CLOSE_SESSION) {
    newState = {
      session: state.session,
      ui: state.ui,
    };
  }

  // $FlowFixMe
  return rootReducer(newState, action);
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/statsradio/redux/reducers.js